// K58 butir 1–4 — FA ADDENDUM di layar FA (AUDIT-B2, 23 Sep 2026).
//
// Trigger `fa_addendum()` sudah menegakkan seluruh aturannya sejak batch24 (induk terkunci, belum
// ber-WO, bukan addendum; DP/tenggat/paket/customer diwarisi; tanda jadi & DP 0) — yang tidak ada
// selama ini hanya PINTU pembuatannya. Komponen ini menampilkan hubungan induk ↔ addendum dan
// tombol "Buat addendum"; penolakan trigger tiba sebagai 409 berpesan jelas.
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { apiErrorMessage } from "../../lib/inventoryApi";
import { Button } from "../ui/button";
import Hint from "./Hint";
import { FA_ORDER_STATUS } from "./StatusBadge";

export default function AddendumFa({ fa, addenda, induk, bolehBuat }) {
  const navigate = useNavigate();
  const [sibuk, setSibuk] = useState(false);

  async function buat() {
    setSibuk(true);
    try {
      const r = await api.post(`/fa-orders/${fa.id}/addendum`, {});
      toast.success(`Addendum ${r.data.fa_number} dibuat — isi itemnya.`);
      navigate(`/fa-orders/${r.data.id}`);
    } catch (e) {
      toast.error(apiErrorMessage(e, "Addendum tidak bisa dibuat."));
    } finally {
      setSibuk(false);
    }
  }

  if (induk) {
    return (
      <div className="rounded-md border border-border p-3 text-sm" data-testid="fa-addendum-induk">
        Ini <b>FA Addendum</b> dari <Link className="underline font-mono" to={`/fa-orders/${induk.id}`}>{induk.fa_number}</Link>.
        DP dan tenggat mengikuti induk; dilunasi bersamaan dengan induk.
      </div>
    );
  }
  if (!(addenda || []).length && !bolehBuat) return null;
  return (
    <div className="rounded-md border border-border p-3 text-sm space-y-2" data-testid="fa-addendum">
      <div className="font-medium">
        FA Addendum{" "}
        <Hint>Tambahan pesanan sesudah FA terkunci dan sebelum masuk WO dibuat sebagai addendum (FA anak). Sesudah masuk WO, tambahan menjadi FA baru.</Hint>
      </div>
      {(addenda || []).length > 0 && (
        <ul className="space-y-0.5">
          {addenda.map((a) => (
            <li key={a.id}>
              <Link className="underline font-mono" to={`/fa-orders/${a.id}`}>{a.fa_number}</Link>
              <span className="text-muted-foreground"> · {FA_ORDER_STATUS[a.order_status]?.l || "—"}</span>
            </li>
          ))}
        </ul>
      )}
      {bolehBuat && (
        <Button size="sm" variant="outline" disabled={sibuk} onClick={buat} data-testid="fa-buat-addendum">
          Buat addendum
        </Button>
      )}
    </div>
  );
}
